import { FunctionComponent, useCallback, useEffect, useState, useContext } from "react"
import { useHistory } from "react-router-dom"
import Logger from "@Classes/Logger"
import SummaryOptions from "@Components/Summary/SummaryOptions"
import IPage from "@Interfaces/IPage"
import UseGetMenuUser from "@Hooks/UseGetMenuUser"
import UseGroupedOrderByCount from "@Hooks/UseGroupedOrderByCount"
import SearchForm from "@Components/SearchForm/SearchForm"
import { ISearchResults } from "@Interfaces/ISearchResults"
import { AuthContext } from "@Context/context/AuthContext"
import { ResourceRoleEnum } from "@Enums/ResourceRoleEnum"

const DashBordScreen: FunctionComponent<IPage> = (props: any) => {

  const {
    state: { user },
  } = useContext(AuthContext)

  const monitorUser = () => {
    return user?.role === ResourceRoleEnum["webapp-monitor-source"]
  }

  const { name } = props
  const history = useHistory()

  const [reload, setReload] = useState(false)

  const { getMenuSummaryOrder } = UseGetMenuUser()

  const { groupedOrder } = UseGroupedOrderByCount()

  const summaryMenuOrder = getMenuSummaryOrder()

  useEffect(() => {
    const st = setTimeout(() => {
      if(monitorUser()) {
        groupedOrder()
        setReload(!reload)
      }
    }, 1000 * 60)

    return () => clearTimeout(st)
    //eslint-disable-next-line
  }, [reload])

  useEffect(() => {
    Logger.info(`Loading ${name}`)
  }, [name])

  const handleClickSearch = useCallback(
    ({ query, optionFilter }: ISearchResults) => {
      if (query) history.push(`/search/${query}/${optionFilter}`)
    },
    [history],
  )

  return (
    <>
      {!monitorUser() && <SearchForm onClickSearch={handleClickSearch} />}
      {summaryMenuOrder && <SummaryOptions summaryOptions={summaryMenuOrder} />}
    </>
  )
}

export default DashBordScreen
